import { useState, useEffect, useContext } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { base_url } from '../url_variables';
import axios from 'axios';
import { UserContext } from "../context/UserContext";
import { GridLoader } from "react-spinners";
import { TopBar } from "../components/topbar";
import { TostMessageContext } from "../context/TostMessage";
import { MenuContext } from "../context/MenuContext";

export default function ProfileSetup() {
  const navigate = useNavigate();
  const {userProfile, setUserProfile, logOutFunction} = useContext(UserContext);
  const [profilePic, setProfilePic] = useState(null);
  const [preview, setPreview] = useState(null);
  const [cookies, setCookie] = useCookies();
  const [profileData, setProfileData] = useState(null);
  const [formData, setFormData] = useState({first_name: userProfile?.defaults?.first_name, last_name: userProfile?.defaults?.last_name, email: userProfile?.defaults?.email, phone_number: userProfile?.defaults?.phone_number });
  const [loaading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const {setTostMessage} = useContext(TostMessageContext)
  const {menuOpen, setMenuOpen} = useContext(MenuContext)

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
    }, [])

  // Handle profile picture upload & preview
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfilePic(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // Handle input changes
  const handleChange = async (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit form
  const handleSubmit = async () => {
    // e.preventDefault();
    console.log("Updated Profile:", formData, profilePic);

    setLoading(true);
    const postData = new FormData();

    for (const [key, value] of Object.entries(formData)) {
        postData.append(key, value);
    }
    postData.append('profilePic', profilePic);

    try {
        const response = await axios.post(base_url + '/update-profile.php', postData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "token": cookies?.userProfile?.session,
                "accountid": cookies?.userProfile?.main_id,
            },
        });
        if (response.data.status) {
            setLoading(false);
            setTostMessage({
                messageType: "success",
                message: response.data.message,
            });
            reloadUserData();
            // window.location.reload();
        } else {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: response.data.message,
            });
        }
    } catch (error) {
        setLoading(false);
        setTostMessage({
            messageType: "error",
            message: "Network Error",
        });
    }
  };

    useEffect(() => {
        getData();
    }, [])

    async function getData() {
        setPageLoading(true)
        try {
            const response = await axios.get(base_url + '/profile.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            console.log(response.data)
            if (response.data.status) {
                setProfileData(response.data.data);
                setFormData(response.data.data);
            } else {

            }
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
        }
    }

    async function reloadUserData() {
        const date = new Date();
        let expiresDate = date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 24 hours
        try {
            const response = await axios.get(base_url + '/get_user_details.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            if (response.data.status) {
                setCookie("userProfile", response.data.user, {
                    path: "/",
                    maxAge: expiresDate,
                    secure: true,
                });
                setUserProfile(response.data.user);
            } else {

            }
        } catch (error) {
            
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
        {pageLoading && (
        <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
            <GridLoader
                color={'#037684'}
                loading={true}
                size={20}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
        )}
        <TopBar title={'Edit Profile'} />
        <form className="space-y-5 pb-6 px-10 mt-5 md:mt-0">
            {/* Profile Picture */}
            <div className="flex flex-col items-center">
            <label htmlFor="profilePic" className="cursor-pointer">
                <img
                src={preview || formData?.profile_picture}
                alt="Profile Preview"
                className="w-28 h-28 object-cover rounded-full border-4 border-gray-200 shadow-md"
                />
            </label>
            <input
                type="file"
                id="profilePic"
                accept="image/*"
                onChange={handleImageChange}
                className="hidden"
            />
            <p className="text-sm text-gray-500 mt-2">Click to change picture</p>
            </div>

            {/* Name */}
            <div className="flex flex-row w-full justify-between">
                <div className="w-[44%]">
                    <label className="block font-medium">First Name</label>
                    <input
                        type="text"
                        name="first_name"
                        value={formData?.first_name}
                        onChange={handleChange}
                        placeholder="Enter your first name"
                        className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
                    />
                </div>
                <div className="w-[44%]">
                    <label className="block font-medium">Last Name</label>
                    <input
                        type="text"
                        name="last_name"
                        value={formData?.last_name}
                        onChange={handleChange}
                        placeholder="Enter your last name"
                        className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
                    />
                </div>
            </div>

            {/* Email */}
            <div>
            <label className="block font-medium">Email</label>
            <input
                type="email"
                name="email"
                value={formData?.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
            />
            </div>

            {/* Phone */}
            <div>
            <label className="block font-medium">Phone Number</label>
            <input
                type="phone"
                name="phone_number"
                value={formData?.phone_number}
                onChange={handleChange}
                placeholder="Enter your phone number"
                className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
            />
            </div>

            {/* Save Button */}
            <div className="text-center mt-[20px] w-full flex justify-center md:justify-end">
            <button
                type="button"
                onClick={() => handleSubmit()}
                className={`px-6 py-2 bg-primary text-white rounded-lg hover:bg-[#037684] transition ${profileData == formData ? 'opacity-[0.7]' : ''}`}
            >
                Save Changes
            </button>
            </div>
      </form>
    </div>
  );
}
